(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hero rotation controller.
   *
   * Manages crossfading between up to 4 muted background videos. Foreground
   * content is unaffected. Pauses when offscreen or when the tab is hidden,
   * and resumes from the same slide. Respects prefers-reduced-motion (no
   * rotation, no transitions).
   *
   * Uses ES5 syntax (var, function expressions) because {% raw %}{% javascript %}{% endraw %}
   * blocks run without a transpilation step.
   */
  (function () {
    'use strict';

    var DEFAULT_VIDEO_DURATION_S = 6;
    var DEFAULT_CROSSFADE_S = 1.5;
    var ACTIVE_CLASS = 'is-active';
    var POSTER_HIDDEN_CLASS = 'is-poster-hidden';

    var prefersReducedMotion = false;
    if (window.matchMedia) {
      prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // registry of active controllers so a single visibilitychange listener
    // can pause/resume them all (avoids one listener per instance).
    var controllers = [];
    var visibilityListenerAttached = false;

    function attachVisibilityListenerOnce() {
      if (visibilityListenerAttached) return;
      visibilityListenerAttached = true;
      document.addEventListener('visibilitychange', function () {
        for (var i = 0; i < controllers.length; i++) {
          if (document.hidden) {
            controllers[i].pause();
          } else {
            controllers[i].resumeIfVisible();
          }
        }
      });
    }

    function safeNumber(value, fallback) {
      var n = parseFloat(value);
      if (!isFinite(n) || n <= 0) return fallback;
      return n;
    }

    function createController(rotation) {
      var slides = rotation.querySelectorAll('[data-rotation-slide]');
      var videos = rotation.querySelectorAll('[data-rotation-video]');

      if (slides.length === 0) return null;

      var videoDurationMs = safeNumber(
        rotation.getAttribute('data-video-duration'),
        DEFAULT_VIDEO_DURATION_S
      ) * 1000;
      var crossfadeMs = safeNumber(
        rotation.getAttribute('data-crossfade-duration'),
        DEFAULT_CROSSFADE_S
      ) * 1000;

      var current = 0;
      var timerId = null;
      var isVisible = false;
      var hasStarted = false;

      function playVideoSafely(video) {
        // Safari/iOS may reject autoplay if the page hasn't been interacted with.
        // The poster/static image stays visible underneath, so a rejection is
        // not a user-facing failure — we just let it sit.
        if (!video) return;
        try {
          video.currentTime = 0;
        } catch (timeErr) {
          // some video states (loading, error) reject seek; safe to ignore
        }
        var playPromise;
        try {
          playPromise = video.play();
        } catch (playErr) {
          // older browsers throw synchronously; treat same as rejection
          return;
        }
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function (autoplayErr) {
            // expected on Safari without user gesture; not a real error
          });
        }
      }

      function pauseVideoSafely(video) {
        if (!video) return;
        try {
          video.pause();
        } catch (pauseErr) {
          // no recoverable case — ignore
        }
      }

      function activateSlide(index) {
        for (var i = 0; i < slides.length; i++) {
          if (i === index) {
            slides[i].classList.add(ACTIVE_CLASS);
          } else {
            slides[i].classList.remove(ACTIVE_CLASS);
          }
        }

        for (var v = 0; v < videos.length; v++) {
          if (v === index) {
            playVideoSafely(videos[v]);
          } else {
            pauseVideoSafely(videos[v]);
          }
        }

        rotation.classList.add(POSTER_HIDDEN_CLASS);
      }

      function advance() {
        current = (current + 1) % slides.length;
        activateSlide(current);
      }

      function startTimer() {
        if (timerId !== null) return;
        if (prefersReducedMotion || slides.length < 2) return;
        timerId = window.setInterval(advance, videoDurationMs);
      }

      function stopTimer() {
        if (timerId !== null) {
          window.clearInterval(timerId);
          timerId = null;
        }
      }

      function start() {
        if (hasStarted) return;
        hasStarted = true;

        // upgrade preload on the first video so the first paint plays smoothly
        if (videos.length > 0) {
          videos[0].setAttribute('preload', 'auto');
          try {
            videos[0].load();
          } catch (loadErr) {
            // some browsers throw if load() is called before the element is ready
          }
        }

        activateSlide(0);
        startTimer();
      }

      function pause() {
        stopTimer();
        for (var v = 0; v < videos.length; v++) {
          pauseVideoSafely(videos[v]);
        }
      }

      function resumeIfVisible() {
        if (!isVisible || document.hidden) return;
        if (videos[current]) playVideoSafely(videos[current]);
        startTimer();
      }

      function setVisibility(visible) {
        isVisible = visible;
        if (visible) {
          if (!hasStarted) {
            start();
          } else {
            resumeIfVisible();
          }
        } else {
          pause();
        }
      }

      return {
        element: rotation,
        setVisibility: setVisibility,
        pause: pause,
        resumeIfVisible: resumeIfVisible
      };
    }

    function initRotation(rotation) {
      // skip if this rotation block isn't currently displayed (desktop vs mobile)
      var styles = window.getComputedStyle(rotation);
      if (styles.display === 'none') return;

      // skip if already initialized (defensive against shopify section reloads)
      if (rotation.hasAttribute('data-rotation-initialized')) return;
      rotation.setAttribute('data-rotation-initialized', 'true');

      var controller = createController(rotation);
      if (!controller) return;

      controllers.push(controller);
      attachVisibilityListenerOnce();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              controller.setVisibility(entries[i].isIntersecting);
            }
          },
          { threshold: 0.1 }
        );
        observer.observe(rotation);
      } else {
        // IE / very old browsers: just start, no visibility tracking
        controller.setVisibility(true);
      }
    }

    function initAll(root) {
      var scope = root || document;
      var rotations = scope.querySelectorAll('[data-hero-rotation]');
      for (var i = 0; i < rotations.length; i++) {
        initRotation(rotations[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // re-init when shopify reloads a section in the editor
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    // on unload of a section in the editor, drop its controllers from the registry
    document.addEventListener('shopify:section:unload', function (event) {
      var unloaded = event.target.querySelectorAll('[data-hero-rotation]');
      for (var i = 0; i < unloaded.length; i++) {
        for (var j = controllers.length - 1; j >= 0; j--) {
          if (controllers[j].element === unloaded[i]) {
            controllers[j].pause();
            controllers.splice(j, 1);
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
